import { render, staticRenderFns } from "./Codigos_influencers.vue?vue&type=template&id=48be3568&"
import script from "./Codigos_influencers.vue?vue&type=script&lang=js&"
export * from "./Codigos_influencers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports